var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container-fluid section-styles"},[_c('div',{staticClass:"quote-wrapper"},[_c('div',{staticClass:"quote"},[_c('img',{staticClass:"quotation-mark",attrs:{"src":require("../../../assets/quote.svg"),"alt":""}}),_vm._v("\n      "+_vm._s(_vm.quote)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }